/**
 * Compatibility shim. The widget-creation orchestration moved into
 * `WorkspaceServiceImpl` per ADR 0008 §New flow — Redux dispatches that
 * trigger widget creation now route through these saga handlers, which
 * forward to the WorkspaceService.
 *
 * Direct callers should call `workspaceService.addWidget(...)` instead of
 * dispatching `addWidgetToDashboard` actions; this saga exists for the
 * action-creator helpers (`addWidgetToDashboardInRect`,
 * `addWidgetToTemplateSlot`, etc.) that haven't been ported to call WS
 * directly.
 */

import { all, call, getContext, takeLatest } from 'redux-saga/effects';
import type { AddWidgetToDashboardAction } from 'src/store/actions/container';
import type { AddNewWidgetToContainerAction } from 'src/store/actions/tab';
import type { SagaContext } from 'src/store/types';

export function* addWidgetToDashboardSaga(action: AddWidgetToDashboardAction) {
    const ctx: SagaContext['container'] = yield getContext('container');
    const ws = ctx.get('WorkspaceService');
    yield call([ws, 'handleAddWidgetAction'], action);
}

export function* createWidgetTabSaga(action: AddNewWidgetToContainerAction) {
    const ctx: SagaContext['container'] = yield getContext('container');
    const ws = ctx.get('WorkspaceService');
    yield call([ws, 'handleAddNewWidgetToContainerAction'], action);
}

export function* widgetConstructionSagas() {
    yield all([
        takeLatest('addWidgetToDashboard', addWidgetToDashboardSaga),
        takeLatest('addNewWidgetToContainer', createWidgetTabSaga),
    ]);
}
